import(/* webpackMode: "eager" */ "/home/interim/frontend/app/technologies/page.tsx");
